import React from 'react';

const ContactUsPage: React.FC = () => {
  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'left',
        color: '#fff',
        backgroundColor: '#0D0713',
        minHeight: '100vh',
        fontFamily: 'Libre Franklin, sans-serif',
      }}
    >
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h1>Contact Us</h1>

        <p style={{ marginBottom: '1em' }}>
          Have questions, feedback, photo submissions, or just want to say
          hello? We'd love to hear from you!
        </p>
        <p style={{ marginBottom: '1em' }}>Please reach out to us via email:</p>
        <p style={{ marginBottom: '1em' }}>
          <a
            href="mailto:whichyrgame@gmail.com"
            style={{ color: '#C6A4FF', textDecoration: 'underline' }}
          >
            whichyrgame@gmail.com
          </a>
        </p>

        <p style={{ marginBottom: '1em' }}>
          We do our best to respond to all inquiries as promptly as possible.
        </p>
        <p style={{ marginBottom: '1em' }}>You can also find us on:</p>
        <ul style={{ marginBottom: '1em' }}>
          <li style={{ marginBottom: '0.5em' }}>
            <a
              href="https://x.com/youbetchaaaaa"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#C6A4FF' }}
            >
              X (formerly Twitter)
            </a>
          </li>
          <li style={{ marginBottom: '0.5em' }}>
            <a
              href="https://bsky.app/profile/chriscreguer.bsky.social"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#C6A4FF' }}
            >
              Bluesky
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
export default ContactUsPage;
